// @flow

import type {Action} from '../../types'
import type {HospitalState} from '../types'
import type {SetSelectedCityPayload} from '../actions/setSelectedCity'

export function setSelectedCityReducer(state: HospitalState, action: Action<SetSelectedCityPayload>): HospitalState {

  return {
    ...state,
    selectedCity: action.payload.city,
  }
}
